/**
 * Hash-Routen der Anwendung. Die Umgebung steht in der Adresse, damit ein
 * Link direkt in ein bestimmtes Buero fuehrt und ein Reload dort bleibt.
 */
export type Route =
  | { kind: 'start' }
  | { kind: 'auswahl' }
  | { kind: 'office'; umgebungId: string }
  | { kind: 'admin'; umgebungId: string }
  | { kind: 'editor'; umgebungId: string }
  | { kind: 'superadmin' }
  | { kind: 'unbekannt' };

export const AUSWAHL_ROUTE = '/auswahl';
export const SUPERADMIN_ROUTE = '/superadmin';

export const officeRoute = (umgebungId: string): string => `/u/${encodeURIComponent(umgebungId)}`;
export const adminRoute = (umgebungId: string): string => `${officeRoute(umgebungId)}/admin`;
export const editorRoute = (umgebungId: string): string => `${officeRoute(umgebungId)}/editor`;

export function parseRoute(hash: string): Route {
  const pfad = hash.replace(/^#/, '').replace(/\/+$/, '') || '/';
  if (pfad === '/') return { kind: 'start' };
  if (pfad === AUSWAHL_ROUTE) return { kind: 'auswahl' };
  if (pfad === SUPERADMIN_ROUTE) return { kind: 'superadmin' };

  const teile = pfad.split('/').slice(1);
  if (teile[0] !== 'u' || !teile[1]) return { kind: 'unbekannt' };
  const umgebungId = decodeURIComponent(teile[1]);
  if (teile.length === 2) return { kind: 'office', umgebungId };
  if (teile.length === 3 && teile[2] === 'admin') return { kind: 'admin', umgebungId };
  if (teile.length === 3 && teile[2] === 'editor') return { kind: 'editor', umgebungId };
  return { kind: 'unbekannt' };
}
